import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';
import { getMetricsFormula } from '@shared/constants/dashboard/campaign-table-constants';
import { formatValuesForDisplayBasedOnType } from '../utils/strings';
import { GOOGLE_ADS_CAMPAIGN_METRICS } from './tables-metrics.constants';
import { NAME } from './tables.constants';

export const getTotalColumn = (column, rows) => {
    const { metric } = column;
    const { type, value } = metric;
    const campaigns = rows.map(row => row.original);
    const prefix = column.id.replace(value, '');

    const isString = type === METRICS_TYPES.string;
    if (isString) return '';

    const calculatedMetrics = getCalculatedMetrics(campaigns, column.id, prefix);

    const total = calculatedMetrics[column.id]
        ? calculatedMetrics[column.id]
        : rows.reduce((sum, row) => sum + (row?.original[column.id] || 0), 0);

    return formatValueToCell(total, column);
};

const getCalculatedMetrics = (metrics, column, prefix = '') => {
    if (!getMetricsFormula(prefix)[column]) return [];
    const metricFormula = getMetricsFormula(prefix)[column];
    const { dividend, divider, multiplier } = metricFormula;
    const calculatedMetricInCampaigns = metrics.reduce(
        (total, metric) => {
            const tempDividend = sumValueOrZero(total.dividend);
            const tempDivider = sumValueOrZero(total.divider);

            return ({
                ...total,
                dividend: tempDividend + sumValueOrZero(metric[dividend]),
                divider: tempDivider + sumValueOrZero(metric[divider]),
            });
        }, {},
    );

    return (
        {
            [column]: calculateMetricObtainableThruDivision(
                calculatedMetricInCampaigns, multiplier,
            ),
        }
    );
};

const calculateMetricObtainableThruDivision = ({ dividend, divider }, multiplier) => {
    if (!divider || !dividend) return 0;

    return multiplier * dividend / divider;
};

const sumValueOrZero = value => (value || 0);

export const formatValueToCell = (value, column) => {
    const { metric } = column;
    const { type } = metric;

    const isPercentage = type === METRICS_TYPES.percent;

    const isString = type === METRICS_TYPES.string;

    const multiplier = isPercentage ? 100 : 1;

    const finalValue = isString ? value : value * multiplier;

    return formatValuesForDisplayBasedOnType(finalValue, type);
};

export const getFilteredData = (campaigns, stringToFilter) => {
    if (stringToFilter) {
        return campaigns
            .filter(campaign => campaign[NAME].toLowerCase()
                .includes(stringToFilter));
    }
    return campaigns;
};

export const getMetricsByContentType = (objectSelected, metrics) => metrics[
    objectSelected.account_selected.selected
        ? objectSelected.account_selected.content_type_name
        : 'client'];

export const getInitialMetrics = (objectSelected) => {
    const initialColumnsForClient = [
        GOOGLE_ADS_CAMPAIGN_METRICS.cost.value,
        GOOGLE_ADS_CAMPAIGN_METRICS.impressions.value,
        GOOGLE_ADS_CAMPAIGN_METRICS.clicks.value,
    ];

    return objectSelected.account_selected.selected
        ? []
        : initialColumnsForClient;
};
